import { useState, useEffect } from "react"
import { handleTrailerComment } from "../helpers"

// const style = {
//   lineHeight: "1",
// }

const Trailer = ({ trailerData }) => {
  const [data, setData] = useState([])

  const handleCommentChanges = (value, id) => {
    const updatedData = data.map((item) => {
      if (item.id == id) {
        return { ...item, ["comments"]: value }
      }
      return item
    })
    setData(updatedData)
  }

  useEffect(() => {
    if (trailerData) {
      setData(trailerData)
    }
  }, [trailerData])

  if (!trailerData) {
    return null
  }
  return (
    <table className='warehouse-dashboard-table'>
      <thead>
        <tr>
          <th>Status</th>
          <th>Trailer #</th>
          <th>Comments</th>
        </tr>
      </thead>
      <tbody>
        {data.map((trailer, index) => (
          <tr
            className={
              trailer.status === "Available"
                ? "warehouse-trailer available"
                : trailer.status === "Unavailable"
                ? "warehouse-trailer unavailable"
                : "warehouse-trailer"
            }
            key={index}
          >
            <td style={{width: '10%'}} className='py-2'>{trailer.status}</td>
            <td style={{width: '10%'}} className='py-2'>{trailer.trailer_no}</td>
            <td className='py-2'>
              <input
                type='text'
                className='form-control'
                value={trailer.comments}
                onChange={(event) =>
                  handleCommentChanges(event.target.value, trailer.id)
                }
                onBlur={() =>
                  handleTrailerComment(trailer.id, trailer.comments)
                }
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default Trailer
